import { push } from 'connected-react-router'
import { Action } from 'redux'
import { Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { StoreDeliveryFeeType } from 'types/storeDeliveryFee'
import { db, FirebaseDocRefType } from 'firebase/index'
import { StockType } from 'types/stock'
import { BreadType } from 'types/bread'

const fetchPrevStoreDeliveryFees = (storeRef: FirebaseDocRefType): Promise<StoreDeliveryFeeType[]> => {
  return storeRef
    .collection('store_delivery_fees')
    .get()
    .then((snapshots) => {
      const list = snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as StoreDeliveryFeeType
        data.ref = snapshot.ref
        return data
      })
      list.sort((a, b) => (a.package_size < b.package_size ? -1 : 1))
      return list
    })
    .catch((error: unknown) => {
      console.error(error)
      return []
    })
}

const saveStoreDeliveryFees = (
  breadList: BreadType[],
  stocks: StockType[],
  storeDeliveryFees: StoreDeliveryFeeType[],
  storeRef: FirebaseDocRefType
) => {
  return async (dispatch: Dispatch<Action>) => {
    const batch = db.batch()
    dispatch(showLoadingAction())
    const prevStoreDeliveryFees = await fetchPrevStoreDeliveryFees(storeRef)
    // ドキュメントの追加・更新
    storeDeliveryFees.forEach((storeDeliveryFee) => {
      const ref =
        prevStoreDeliveryFees.find((prev) => prev.package_size === storeDeliveryFee.package_size)?.ref ||
        storeRef.collection('store_delivery_fees').doc()
      batch.set(ref, storeDeliveryFee, { merge: true })
    })
    // 変更前に存在していたサイズが変更後に存在していなければドキュメントを削除
    prevStoreDeliveryFees.forEach((prev) => {
      if (storeDeliveryFees.some((storeDeliveryFee) => storeDeliveryFee.package_size === prev.package_size)) return
      if (!prev.ref) return
      batch.delete(prev.ref)
    })
    // 在庫数を0にする
    const deletedStocks = stocks.filter((stock) =>
      breadList.some((bread) => bread.bread_ref?.id === stock.bread_ref?.id)
    )
    deletedStocks.forEach((deletedStock) => {
      const nextValue: Pick<StockType, 'stock'> = { stock: 0 }
      if (!deletedStock.stock_ref) return
      batch.set(deletedStock.stock_ref, nextValue, { merge: true })
    })
    await batch.commit()
    dispatch(hideLoadingAction())
    dispatch(push('/delivery/setting/fee/complete'))
  }
}

export default saveStoreDeliveryFees
